import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {UmpireRating} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class RatingService implements CrudService<UmpireRating> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireRating[]>> {
    return this.http
      .get(`/squad_players/ratings`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
